export default "__VITE_ASSET__99f5ee21__"